// extracted by mini-css-extract-plugin
module.exports = {"button":"LogoutButton_button__2m41X","icon":"LogoutButton_icon__2Z2YH"};